import styled from "styled-components";
import { styledByTheme } from "../../../../../themes/architecture/styled-by-theme";
import {GenericSideMenuLinkDefaultBox} from "./generic-side-menu-link.box";

const GenericSideMenuPreIconDefaultBox = styled.span<{active: boolean}>`
`;

const GenericSideMenuPreIconSIBox = styled(GenericSideMenuPreIconDefaultBox)`
    position: absolute;
    top: 0;
    bottom: 0;
    left: -1rem;
    width: 4px;
    border-radius: 0.5rem 0 0 0.5rem;

    background-color: ${(props) => props.active ? props.theme.colors.textActive : "transparent"};
    ${GenericSideMenuLinkDefaultBox}:hover & {
        background-color: ${(props) => props.theme.colors.textActive};
    }
`;

export const GenericSideMenuPreIconBox = styledByTheme(GenericSideMenuPreIconDefaultBox)
    .forSI(GenericSideMenuPreIconSIBox)
    .apply();
